import { useMemo, type HTMLAttributes, type ReactNode } from 'react';

import { cn } from '../../lib/utils.js';

import { InputGroupContext } from './input.js';

export interface InputGroupProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  hasIcon?: boolean;
  hasSuffix?: boolean;
}

export function InputGroup({
  children,
  className,
  hasIcon = false,
  hasSuffix = false,
  ...props
}: InputGroupProps) {
  const value = useMemo(() => ({ hasIcon, hasSuffix }), [hasIcon, hasSuffix]);

  return (
    <InputGroupContext.Provider value={value}>
      <div
        className={cn(
          'input-group',
          hasIcon && 'input-group--has-icon',
          hasSuffix && 'input-group--has-suffix',
          className,
        )}
        {...props}
      >
        {children}
      </div>
    </InputGroupContext.Provider>
  );
}

export interface InputGroupIconProps {
  children: ReactNode;
  className?: string;
}

export function InputGroupIcon({ children, className }: InputGroupIconProps) {
  return <span className={cn('input-icon', className)}>{children}</span>;
}

export interface InputGroupSuffixProps extends HTMLAttributes<HTMLSpanElement> {
  children: ReactNode;
}

export function InputGroupSuffix({ children, className, ...props }: InputGroupSuffixProps) {
  return (
    <span className={cn('input-suffix', className)} {...props}>
      {children}
    </span>
  );
}
